import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import { Box, TextField } from "@mui/material";
import { red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';

export const DeliveryTable = ({ headers, rows, captionText, isEditable, handleChange, error }) => {
    const GetValue = function getUtilValue(countryId, componentId, id) {
        const filterIndex = error?.findIndex(item => item.countryId == countryId && item.componentId === componentId);
        if (filterIndex !== -1) {

            const index = error?.findIndex(item => item.countryId == countryId && item.componentId === componentId && item.wpoDeliveredPercentErrorField === id);
            if (index !== -1) {
                return error[index].wpoDeliveredPercentErrorMessage;
            }
            else {
                const intindex = error?.findIndex(item => item.countryId == countryId && item.componentId === componentId && item.extAffiliateDeliveredErrorField === id);
                if (intindex !== -1) {
                    return error[intindex].extAffiliateDeliveredErrorMessage;
                }

            }
        }
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: "400" }} aria-label="customized table">
                {(captionText) && <caption>{captionText}</caption>}
                <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                    <TableRow>
                        {headers.map((header, index) => (

                            <TableCell key={header.id}>
                                {header.label}
                                {header.id === "cost" && (rows?.[0]?.currencyCode ? ` (${rows?.[0]?.currencyCode})` : '')}
                            </TableCell>
                        ))}

                    </TableRow>
                </TableHead>
                <TableBody >
                    {rows?.map((row, rowIndex) => (

                        <TableRow key={rowIndex} >
                            {headers.map((header) => (


                                <TableCell >
                                    {isEditable && header?.iseditable ?
                                        <>
                                            <TextField
                                                size="small"
                                                defaultValue={row[header.id]}
                                                onChange={(e) => handleChange(row.componentId, row.countryId, header.id, e.target.value)}
                                            />
                                            {!isNaN(GetValue(row.countryId, row.componentId, header.id)) ? GetValue(row.countryId, row.componentId, header.id) : '-'  ?
                                                < Typography variant="caption" sx={{ color: red[500], fontSize: '10px', whiteSpace: 'nowrap' }} display="block" gutterBottom>
                                                    {GetValue(row.countryId, row.componentId, header.id)}
                                                </Typography> :


                                                <div style={{ height: "20px" }}></div>}
                                        </>
                                        :
                                        header.id === 'usage' || header.id === "wpoDeliveredPercent"||header.id==="extAffiliateDelivered"
                                            ? row[header.id] + '%'
                                            : isNaN(row[header.id]) || row[header.id] === "" ? row[header.id] : !isNaN(Number(row[header.id]?.toFixed(2))) ? Number(row[header.id]?.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits: 2 }) : ""
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default DeliveryTable;